import {
  ADD_PROJECTS,
  PROJECT_MANAGEMENT_DL_GROUP_ID_VALIDATE,
  PROJECT_MANAGEMENT_JIRA_PROJECT_ID_VALIDATE,
  PROJECT_MANAGEMENT_PROJECT_DETAILS,
  PROJECT_OVERVIEW,
} from '../../Api/resources/endPoint';
import { serviceName } from '../../Api/resources/serviceConstants';

export const fetchAddProject = (payload, { isMaster = false } = {}) => {
  const requestConfig = isMaster
    ? {
      url: ADD_PROJECTS,
      service: serviceName.PROJECT_MS,
    }
    : {
      url: PROJECT_MANAGEMENT_PROJECT_DETAILS,
      service: serviceName.PROJECT_MS,
    };

  return {
    url: requestConfig.url,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload,
    service: requestConfig.service,
  };
};
export const fetchProjectOverviewList = (payload = {}) => ({
  url: PROJECT_OVERVIEW,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});

export const fetchAddProjectPrefill = ({ projectId, projectSeqId } = {}) => ({
  url: projectSeqId
    ? `${PROJECT_MANAGEMENT_PROJECT_DETAILS}/${encodeURIComponent(String(projectSeqId || ''))}`
    : `${PROJECT_MANAGEMENT_PROJECT_DETAILS}/by-project-id/${encodeURIComponent(String(projectId || ''))}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});

export const updateAddProject = (projectSeqId, payload) => ({
  url: `${PROJECT_MANAGEMENT_PROJECT_DETAILS}/${encodeURIComponent(String(projectSeqId || ''))}`,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});

export const validateDlGroupId = (groupId) => {
  const normalizedGroupId = String(groupId ?? '').trim();
  const query = new URLSearchParams({ groupId: normalizedGroupId });

  return {
    url: `${PROJECT_MANAGEMENT_DL_GROUP_ID_VALIDATE}?${query.toString()}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

export const validateJiraProjectId = (projectId) => {
  const normalizedProjectId = String(projectId ?? '').trim();
  const query = new URLSearchParams({ projectId: normalizedProjectId });

  return {
    url: `${PROJECT_MANAGEMENT_JIRA_PROJECT_ID_VALIDATE}?${query.toString()}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

export const fetchProjectTechnologyList = ({ projectId, techId } = {}) => {
  const query = new URLSearchParams();

  if (projectId !== undefined && projectId !== null && projectId !== '') {
    query.set('projectId', String(projectId));
  }

  if (techId !== undefined && techId !== null && techId !== '') {
    query.set('techId', String(techId));
  }

  return {
    url: `/v1/project-technology${query.toString() ? `?${query.toString()}` : ''}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

export const createProjectTechnology = (payload) => ({
  url: '/v1/project-technology',
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});

export const updateProjectTechnology = (projectTechId, payload) => ({
  url: `/v1/project-technology/${encodeURIComponent(String(projectTechId || ''))}`,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});
